import API from '@/views/Fdc/Apis/'
import Modal from '@/views/Fdc/EqpInfo/Components/Modal'

/**
 * EQP Info > Parameter Manager
 * Parameter 정보 관리
 */
export default {
  name: 'ParameterManager',
  components: {
    'modal': Modal
  },
  watch: {
  },
  beforeMount () {
    this.initColumns()
    this.getCodeList('paramVidType')
    this.getCodeList('paramOffsetType')
    this.getCodeList('paramValType')
    this.getCodeList('paramLevel')
  },
  mounted () {
    // let self = this

    // /**
    //  * excel import function set
    //  */
    // document.getElementById('importFileInput').addEventListener('change', function () {
    //   let fileInput = document.getElementById('importFileInput')
    //   if (fileInput.files[0]) {
    //     if (fileInput.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
    //       fileInput.files[0].type !== 'application/vnd.ms-excel.sheet.macroEnabled.12') {
    //       self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_FILE_EXTENSION', ['xlsx']))
    //       self.resetFileInput()
    //       return ''
    //     }

    //     let reader = new FileReader()
    //     reader.onload = function () {
    //       let workbook = new wjcXlsx.Workbook()
    //       workbook.loadAsync(reader.result, () => {
    //         let excelcell = workbook.sheets[0].rows[0]
    //         // Column 수 계산 (count로 계산)
    //         if (excelcell.cells.length === (self.parameterManagerGrid.columns.length)) {
    //           var count = 0
    //           // header 일치 여부 확인 (count로 계산)
    //           // row header column 빼고 계산
    //           for (var i = 0; i < self.parameterManagerGrid.columns.length; i++) {
    //             if (excelcell.cells[i].value === self.parameterManagerGrid.columns[i].header) {
    //               count++
    //             }
    //           }
    //           // header 일치 시 process start
    //           if (count === self.parameterManagerGrid.columns.length) {
    //             let newRowData = []
    //             for (let i = 0; i < workbook.sheets[0].rows.length - 1; i++) {
    //               let newRow = {}
    //               newRow.fab = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[0].value)
    //               newRow.eqpId = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[1].value)
    //               newRow.moduleId = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[2].value)

    //               newRow.paramName = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[3].value)
    //               newRow.vid = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[4].value)
    //               newRow.vidType = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[5].value)
    //               newRow.paramValType = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[6].value)
    //               newRow.aliasName = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[7].value)
    //               newRow.paramDesc = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[8].value)
    //               newRow.valueUnit = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[9].value)
    //               newRow.useYn = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[10].value)
    //               newRow.numberYn = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[11].value)
    //               newRow.virtualYn = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[12].value)
    //               newRow.listYn = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[14].value)
    //               newRow.listPosition = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[15].value)
    //               newRow.listDelimiter = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[16].value)
    //               newRow.offsetType = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[17].value)
    //               newRow.offsetValue = self.nullValueChk(workbook.sheets[0].rows[i + 1].cells[18].value)

    //               newRow.isNew = true
    //               newRow['_status'] = {}
    //               newRow['_status']['checked'] = true
    //               newRow['_status']['added'] = true
    //               newRow['_status']['modified'] = false
    //               newRowData.push(newRow)
    //             }
    //             self.rowData = newRowData
    //             self.resetFileInput()
    //           } else {
    //             self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_COLUMN'))
    //             self.resetFileInput()
    //           }
    //         } else {
    //           self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_COLUMN'))
    //           self.resetFileInput()
    //         }
    //       })
    //     }
    //     reader.readAsDataURL(fileInput.files[0])
    //   }
    // })
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      const self = this
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', width: 170, required: true, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_LEVEL'), field: 'paramLevel', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VID'), field: 'vid', width: 80, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VID_TYPE'), field: 'vidType', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_VAL_TYPE'), field: 'paramValType', width: 140, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', width: 170, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.UNIT'), field: 'valueUnit', width: 90 },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 90, required: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.NUMBER_TYPE'), field: 'numberYn', width: 120, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), field: 'virtualYn', width: 90, required: true },
        {
          headerName: this.$t('fdc.COMMON.COLUMN.VIRTUAL_DATA'),
          field: 'virtualButton',
          width: 110,
          cellRendererSelector: function (params) {
            const editBtn = {
              frameworkComponent: 'buttonRenderer',
              params: {
                clicked: function (params) {
                  self.editVirtual(params.data)
                },
                btnType: 'is-primary',
                btnIcon: 'open-in-new',
                btnLabel: 'Edit'
              }
            }

            if (params.data.virtualYn === 'Y') return editBtn
            else return undefined
          }
        },
        { headerName: this.$t('fdc.COMMON.COLUMN.LIST_TYPE'), field: 'listYn', width: 100, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.LIST_POSITION'), field: 'listPosition', width: 120, required: true, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.LIST_DELIMITER'), field: 'listDelimiter', width: 110 },
        { headerName: this.$t('fdc.COMMON.COLUMN.OFFSET_TYPE'), field: 'offsetType', width: 110 },
        { headerName: this.$t('fdc.COMMON.COLUMN.OFFSET_VALUE'), field: 'offsetValue', width: 110, required: true, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TEMP_COUNT'), field: 'tempCount', width: 80, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'paramDesc', width: 170 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 130, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
    },
    /**
     * Parameter Manager 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module ID
     */
    async listFn (fab, eqpId, moduleId) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getEqpParams(payload)
      this.rowData = data
      // this.parameterManagerGrid.select(-1, -1)
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Parameter 검색
     */
    searchProcess () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
    },
    /**
     * Parameter Manager Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.parameterManagerGrid) {
        return 0
      }
      return this.$refs.parameterManagerGrid.checkedRowCount > 0
    },
    /**
     * Add Button 활성화 여부 결정
     * @returns {Boolean} Add Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Add Button 활성화 여부를 결정합니다.
     */
    addEnable () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null &&
          selectEqpVo.eqpId !== null &&
          selectEqpVo.moduleId !== null) {
          return true
        }
        return false
      }
    },
    // newRowAdd () {
    //   let selectEqpVo = this.searchTreeNode.detail
    //   let arr = [
    //     {
    //       fab: selectEqpVo.fab,
    //       eqpId: selectEqpVo.eqpId,
    //       moduleId: selectEqpVo.moduleId,
    //       vidType: 'SVID',
    //       paramValType: 'NONE',
    //       paramName: 'NA',
    //       aliasName: 'NA',
    //       useYn: 'Y',
    //       numberYn: 'Y',
    //       virtualYn: 'N',
    //       listYn: 'N',
    //       listPosition: 0,
    //       offsetValue: 0,
    //       tempCount: 0,
    //       isNew: true
    //     }
    //   ]
    //   let status = {
    //     checked: true,
    //     modified: false,
    //     added: true
    //   }
    //   this.$refs.parameterManagerGrid.addRows(arr, status)
    // },
    // updateComboBoxInGrid () {
    //   if (this.parameterManagerGrid) {
    //     let colVidType = this.parameterManagerGrid.columns.getColumn('vidType')
    //     if (colVidType) {
    //       colVidType.dataMapEditor = true
    //       colVidType.dataMap = this.buildDataMap2(this.vidTypeList)
    //     }
    //     let colParamValType = this.parameterManagerGrid.columns.getColumn('paramValType')
    //     if (colParamValType) {
    //       colParamValType.dataMapEditor = true
    //       colParamValType.dataMap = this.buildDataMap2(this.paramValTypeList)
    //     }
    //     let colOffsetType = this.parameterManagerGrid.columns.getColumn('offsetType')
    //     if (colOffsetType) {
    //       colOffsetType.dataMapEditor = true
    //       colOffsetType.dataMap = this.buildDataMap2(this.offsetTypeList)
    //     }
    //     let colUseYn = this.parameterManagerGrid.columns.getColumn('useYn')
    //     if (colUseYn) {
    //       colUseYn.dataMapEditor = true
    //       colUseYn.dataMap = this.buildDataMap(this.useYnList, 'useYn')
    //     }
    //     let colNumberYn = this.parameterManagerGrid.columns.getColumn('numberYn')
    //     if (colNumberYn) {
    //       colNumberYn.dataMapEditor = true
    //       colNumberYn.dataMap = this.buildDataMap(this.numberYnList, 'numberYn')
    //     }
    //     let colVirtualYn = this.parameterManagerGrid.columns.getColumn('virtualYn')
    //     if (colVirtualYn) {
    //       colVirtualYn.dataMapEditor = true
    //       colVirtualYn.dataMap = this.buildDataMap(this.virtualYnList, 'virtualYn')
    //     }
    //     let colListYn = this.parameterManagerGrid.columns.getColumn('listYn')
    //     if (colListYn) {
    //       colListYn.dataMapEditor = true
    //       colListYn.dataMap = this.buildDataMap(this.listYnList, 'listYn')
    //     }
    //   }
    // },
    /**
     * Code 목록 조회
     * @param {String} type code type
     * code type에 대한 code 목록을 조회합니다.
     */
    async getCodeList (type) {
      var payload = {
        codeType: type
      }
      var data = await API.Common.getCodesString(payload)
      if (type === 'paramVidType') {
        this.vidTypeList = data
      } else if (type === 'paramOffsetType') {
        this.offsetTypeList = data
      } else if (type === 'paramValType') {
        this.paramValTypeList = data
      } else if (type === 'paramLevel') {
        this.paramLevelList = data
      }
    },
    // buildDataMap (items, keyName) {
    //   let map = []
    //   for (let i = 0; i < items.length; i++) {
    //     map.push({ key: items[i][keyName], value: items[i][keyName] })
    //   }
    //   return new wjcGrid.DataMap(map, 'key', 'value')
    // },
    // buildDataMap2 (items) {
    //   let map = []
    //   for (let i = 0; i < items.length; i++) {
    //     map.push({ key: items[i], value: items[i] })
    //   }
    //   return new wjcGrid.DataMap(map, 'key', 'value')
    // },
    /**
     * Parameter Manager Grid 재조회
     */
    refreshGrid () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail
        this.listFn(selectEqpVo.fab, selectEqpVo.eqpId, selectEqpVo.moduleId)
      }
    },
    // async saveData () {
    //   let self = this
    //   let allRows = this.$refs.parameterManagerGrid.grid.rows
    //   let checkedRows = common.getCheckedRows(allRows)

    //   if (checkedRows < 1) {
    //     this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
    //     return
    //   }

    //   let modifiedRows = common.getModifiedRows(allRows)
    //   let addedRows = common.getAddedRows(allRows)

    //   let mustSaveRows = []

    //   let rowCompareCnt = 0

    //   for (let i in checkedRows) {
    //     if (!checkedRows[i].isNew) {
    //       for (let k in modifiedRows) {
    //         if (JSON.stringify(checkedRows[i]) === JSON.stringify(modifiedRows[k])) {
    //           rowCompareCnt += 1
    //         }
    //       }
    //     } else {
    //       for (let l in addedRows) {
    //         if (JSON.stringify(checkedRows[i]) === JSON.stringify(addedRows[l])) {
    //           rowCompareCnt += 1
    //         }
    //       }
    //     }
    //     var data = checkedRows[i]
    //     mustSaveRows.push(data)
    //   }

    //   if ((mustSaveRows.length) < 1) {
    //     this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Edit Items']))
    //     return
    //   }

    //   if (!this.saveValidation(mustSaveRows)) {
    //     return
    //   }

    //   let message = ''
    //   if (rowCompareCnt !== (addedRows.length + modifiedRows.length)) {
    //     message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
    //   }

    //   message += (mustSaveRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_SAVE')

    //   this.$dialog.confirm({
    //     message: message,
    //     cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
    //     confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
    //     onConfirm: function () {
    //       function saveLastProcess (response) {
    //         if (response != null && response.status === 200) {
    //           self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
    //           let node = self.searchTreeNode
    //           if (node.detail) {
    //             self.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
    //           } else {
    //             self.parameterManagerGrid.collectionView.refresh()
    //           }
    //         } else {
    //           self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
    //         }
    //       }

    //       if (mustSaveRows.length > 0) {
    //         API.FdcEqpInfo.saveParam(mustSaveRows).then(result => {
    //           saveLastProcess(result)
    //         })
    //       }
    //     },
    //     onCancel: function () {}
    //   })
    // },
    // saveValidation (rows) {
    //   for (let i in rows) {
    //     if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp ID']))
    //       // this.$dialog.alert('EQP ID가 없습니다.')
    //       return false
    //     } else if (!rows[i].moduleId || rows[i].moduleId.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Module ID']))
    //       // this.$dialog.alert('Module ID가 없습니다.')
    //       return false
    //     } else if (!rows[i].vid || rows[i].vid.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Vid']))
    //       // this.$dialog.alert('VID 가 없습니다.')
    //       return false
    //     } else if (!rows[i].vidType || rows[i].vidType.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Vid Type']))
    //       // this.$dialog.alert('VID Type이 없습니다.')
    //       return false
    //     } else if (!rows[i].paramValType || rows[i].paramValType.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Param Value Type']))
    //       return false
    //     } else if (!rows[i].paramName || rows[i].paramName.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Parameter Name']))
    //       // this.$dialog.alert('Parameter Name이 없습니다.')
    //       return false
    //     } else if (!rows[i].aliasName || rows[i].aliasName.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Alias Name']))
    //       // this.$dialog.alert('Alias Name이 없습니다.')
    //       return false
    //     } else if (!rows[i].useYn || rows[i].useYn.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Use YN']))
    //       // this.$dialog.alert('USE YN이 없습니다.')
    //       return false
    //     } else if (!rows[i].numberYn || rows[i].numberYn.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Number YN']))
    //       // this.$dialog.alert('Number YN이 없습니다.')
    //       return false
    //     } else if (!rows[i].virtualYn || rows[i].virtualYn.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Virtual YN']))
    //       // this.$dialog.alert('Virtual YN이 없습니다.')
    //       return false
    //     } else if (!rows[i].listYn || rows[i].listYn.trim() === '') {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['List YN']))
    //       // this.$dialog.alert('List YN이 없습니다.')
    //       return false
    //     } else if (rows[i].listPosition === '' || rows[i].listPosition === undefined) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['List Position']))
    //       // this.$dialog.alert('List Position이 없습니다.')
    //       return false
    //     } else if (rows[i].tempCount === '' || rows[i].tempCount === undefined) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Temp Count']))
    //       return false
    //     }
    //     let isNotVidType = true
    //     for (let j in this.vidTypeList) {
    //       if (rows[i].vidType === this.vidTypeList[j]) {
    //         isNotVidType = false
    //       }
    //     }
    //     if (isNotVidType) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['VID Type']))
    //       return false
    //     }
    //     let isNotParamValType = true
    //     for (let j in this.paramValTypeList) {
    //       if (rows[i].paramValType === this.paramValTypeList[j]) {
    //         isNotParamValType = false
    //       }
    //     }
    //     if (isNotParamValType) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Param Value Type']))
    //       return false
    //     }
    //     let isNotOffsetType = true
    //     for (let j in this.offsetTypeList) {
    //       if (!rows[i].offsetType) {
    //         isNotOffsetType = false
    //       } else {
    //         if (rows[i].offsetType === this.offsetTypeList[j]) {
    //           isNotOffsetType = false
    //         }
    //       }
    //     }
    //     if (isNotOffsetType) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Offset Type']))
    //       return false
    //     }
    //     let isNotUseYn = true
    //     for (let j in this.useYnList) {
    //       if (rows[i].useYn === this.useYnList[j].useYn) {
    //         isNotUseYn = false
    //       }
    //     }
    //     if (isNotUseYn) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Use YN']))
    //       return false
    //     }
    //     let isNotNumberYn = true
    //     for (let j in this.numberYnList) {
    //       if (rows[i].numberYn === this.numberYnList[j].numberYn) {
    //         isNotNumberYn = false
    //       }
    //     }
    //     if (isNotNumberYn) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Number YN']))
    //       return false
    //     }
    //     let isNotVirtualYn = true
    //     for (let j in this.virtualYnList) {
    //       if (rows[i].virtualYn === this.virtualYnList[j].virtualYn) {
    //         isNotVirtualYn = false
    //       }
    //     }
    //     if (isNotVirtualYn) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Virtual YN']))
    //       return false
    //     }
    //     let isNotListYn = true
    //     for (let j in this.listYnList) {
    //       if (rows[i].listYn === this.listYnList[j].listYn) {
    //         isNotListYn = false
    //       }
    //     }
    //     if (isNotListYn) {
    //       this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['List YN']))
    //       return false
    //     }
    //   }
    //   return true
    // },
    // async cellEditEnd (grid, event) {
    //   let col = grid.columns[event.col]
    //   let rowData = grid.rows[event.row]._data
    //   let rowStatus = grid.rows[event.row]._data._status

    //   // modified and added row 시 자동 check (checkbox column 제외)
    //   if (col.binding !== '_status.checked') {
    //     if (rowStatus.modified || rowStatus.added) {
    //       rowStatus.checked = true
    //     }
    //     // else {
    //     //   rowStatus.checked = false
    //     // }
    //   }

    //   // key validation
    //   if (rowData.isNew && rowData.eqpId && rowData.moduleId && rowData.paramName) {
    //     if (col.binding === 'paramName') {
    //       let payload = {
    //         fab: rowData.fab,
    //         eqpId: rowData.eqpId,
    //         moduleId: rowData.moduleId,
    //         paramName: rowData.paramName
    //       }
    //       let result = await API.FdcEqpInfo.paramKeyValidation(payload)
    //       if (result > 0) {
    //         this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //         rowData.paramName = null
    //       } else {
    //         if (!this.newRowsKeyValidation(payload)) {
    //           this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //           rowData.paramName = null
    //         }
    //       }
    //     }
    //   }
    // },
    /**
     * Parameter 삭제
     * 실제 삭제가 아니라 Use YN만 'N'으로 변경합니다.
     */
    async deleteData () {
      let self = this
      // let allRows = this.$refs.parameterManagerGrid.grid.rows
      // let checkedRows = common.getCheckedRows(allRows)
      const checkedRows = this.$refs.parameterManagerGrid.gridApi.getSelectedRows()

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let mustDeleteRows = []
      for (let i in checkedRows) {
        let isCreate = true
        if (!checkedRows[i].isNew) {
          isCreate = false
        }
        var data = checkedRows[i]
        if (!isCreate) {
          mustDeleteRows.push(data)
        }
      }

      let message = (mustDeleteRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              let node = self.searchTreeNode
              self.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (mustDeleteRows.length > 0) {
            API.BaseInfo.putEqpParam(mustDeleteRows).then(result => {
              deleteLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    /**
     * Virtual Parameter 화면 연동
     * @param {Object} item Parameter Object
     * 현재 Virtual Parameter의 Virtual Data(Javascript Function)를 정의할 수 있는 창으로 이동합니다.
     */
    editVirtual (item) {
      let routeData = this.$router.resolve(
        {
          name: 'virtual-parameter',
          query: {
            fab: item.fab,
            eqpId: item.eqpId,
            moduleId: item.moduleId,
            paramName: item.paramName
          }
        }
      )
      window.open(routeData.href, '_blank')
      // this.parameterManagerGrid.invalidate()
    },
    // newRowsKeyValidation (params) {
    //   let allRows = this.$refs.parameterManagerGrid.grid.rows
    //   let addedRows = common.getAddedRows(allRows)
    //   let result = true
    //   let sameDataCnt = 0
    //   for (var i in addedRows) {
    //     if (addedRows[i].fab === params.fab &&
    //       addedRows[i].eqpId === params.eqpId &&
    //       addedRows[i].moduleId === params.moduleId &&
    //       addedRows[i].paramName === params.paramName &&
    //       addedRows[i].paramName) {
    //       // result = false
    //       // break
    //       sameDataCnt++
    //     }
    //   }
    //   if (sameDataCnt > 1) {
    //     result = false
    //   }
    //   return result
    // },
    /**
     * Excel Export
     * 조회된 결과를 Excel 파일로 저장합니다.
     */
    exportExcel () {
      // visible change
      // let unvisibleArr = []
      // for (var i = 0; i < this.columns.length; i++) {
      //   if (!this.columns[i].visible && this.columns[i].visible !== undefined) {
      //     this.columns[i].visible = true
      //     unvisibleArr.push(this.columns[i].binding)
      //   }
      // }

      // // export excel
      // setTimeout(() => {
      //   this.$refs.parameterManagerGrid.exportExcel('ParameterManager')
      //   // visible reset
      //   for (var j = 0; j < this.columns.length; j++) {
      //     if (unvisibleArr.includes(this.columns[j].binding)) {
      //       this.columns[j].visible = false
      //     }
      //   }
      // })
      this.$refs.parameterManagerGrid.gridApi.exportDataAsCsv({
        fileName: 'ParameterManager.csv'
      })
    },
    /**
     * Excel Import
     * excel을 import 할 수 있도록 파일 선택창을 띄웁니다.
     */
    importExcel () {
      this.resetFileInput()
      document.getElementById('importFileInput').click()
    },
    /**
     * File value 초기화
     * 선택된 파일을 초기화 합니다.
     */
    resetFileInput () {
      document.getElementById('importFileInput').value = ''
    },
    /**
     * Excel Import 시 cell data null 체트
     * @param {*} value cell data
     * @returns {*} value가 undefined일 경우 null return, 아닐 경우엔 string으로 변환하여 return
     */
    nullValueChk (value) {
      return value ? value.toString() : null
    },
    /**
     * Parameter Edit Modal 열기
     */
    openEditModal () {
      this.parameterSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0019')

      // const rows = this.$refs.parameterManagerGrid.grid.rows.filter(row => row.dataItem._status)
      // const data = rows.find(row => row.dataItem._status.checked).dataItem
      const data = this.$refs.parameterManagerGrid.getCheckedRows()[0]
      data.saveType = 'Edit'
      this.initValue = data
    },
    /**
     * Parameter Add Modal 열기
     */
    openAddModal () {
      this.parameterSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0020')

      const data = this.searchTreeNode.detail
      this.initValue = {
        saveType: 'Add',
        fab: data.fab,
        eqpId: data.eqpId,
        moduleId: data.moduleId
      }
    },
    /**
     * Parameter Manager Grid에 check된 row count가 1개인지 확인
     * @returns {Boolean} check된 1개인지 여부
     * Edit 가능 여부에 대해서 판단하여 button 활성화 값이 달라집니다.
     */
    hasOneCheckedRow () {
      if (!this.$refs.parameterManagerGrid) {
        return 0
      }
      return this.$refs.parameterManagerGrid.checkedRowCount === 1
    },
    /**
     * Parameter Add/Edit Modal data 초기화
     */
    resetSaveInitValue () {
      this.initValue = {}
    },
    /**
     * Parameter Add/Edit Modal close
     */
    closeSaveModal () {
      this.parameterSaveModal.visible = false
    },
    /**
     * Edit Button click event
     * check된 row가 없는 상태에서 click 시 alert를 띄웁니다.
     */
    clickDisabledEditButton () {
      if (this.$refs.parameterManagerGrid.checkedRowCount !== 1) {
        this.$dialog.alert('Check a row to edit Parameter')
      }
    }
  },
  data () {
    return {
      parameterManagerGrid: null, // Parameter Manager Grid 객체
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), binding: 'paramName', width: 170, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.VID'), binding: 'vid', width: 80, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.VID_TYPE'), binding: 'vidType', width: 100, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.PARAM_VAL_TYPE'), binding: 'paramValType', width: 140, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', width: 170, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.UNIT'), binding: 'valueUnit', width: 90, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.USABLE'), binding: 'useYn', width: 90, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.NUMBER_TYPE'), binding: 'numberYn', width: 120, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), binding: 'virtualYn', width: 90, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.VIRTUAL_DATA'), binding: 'virtualButton', width: 110, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LIST_TYPE'), binding: 'listYn', width: 100, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.LIST_POSITION'), binding: 'listPosition', width: 120, required: true, dataType: 'Number', modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.LIST_DELIMITER'), binding: 'listDelimiter', width: 110, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.OFFSET_TYPE'), binding: 'offsetType', width: 110, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.OFFSET_VALUE'), binding: 'offsetValue', width: 110, required: true, dataType: 'Number', modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.TEMP_COUNT'), binding: 'tempCount', width: 80, required: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), binding: 'paramDesc', width: 170, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 130, readOnly: true, dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true }
      // ], // grid column 배열
      columns: [], // grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      vidTypeList: [], // Vid Type 목록 배열
      offsetTypeList: [], // Offset Type 목록 배열
      paramValTypeList: [], // Parameter Value Type 목록 배열
      paramLevelList: [], // Parameter Level 목록 배열
      // useYnList: [
      //   { useYn: 'Y' },
      //   { useYn: 'N' }
      // ],
      // numberYnList: [
      //   { numberYn: 'Y' },
      //   { numberYn: 'N' }
      // ],
      // virtualYnList: [
      //   { virtualYn: 'Y' },
      //   { virtualYn: 'N' }
      // ],
      // listYnList: [
      //   { listYn: 'Y' },
      //   { listYn: 'N' }
      // ],
      modalTitle: '', // Parameter Save Modal Title
      initValue: {}, // Parameter Save Modal 초기 data
      parameterSaveModal: {
        visible: false
      } // Parameter Save Modal 표시 여부
    }
  }
}
